import angular from 'angular';

import cmsGridDirective from '../../Grid/GridDirective';
import GridParamsConverter from '../../Grid/GridParamsConverter';
import PageResource from '../PageResource'
import gettext from 'angular-gettext';
import appConfig from '../../ConfigModule/ConfigModule'

let productsGridModule = angular.module('cms.pages.grid', [cmsGridDirective, PageResource, gettext, appConfig, GridParamsConverter])
    .component('pagesGrid', {
        template: require('./pages-grid.html'),
        bindings: {
            initialParams: '<?',
            onParamsChange: '&?',
            onPageChange: '&?',
        },
        controller: function (PageResource, gettextCatalog, toastr, CONFIG, GridParamsConverter, $state) {
            /** @ngInject */

            let getColumnDefs = () => {
                return [
                    {
                        headerName: gettextCatalog.getString("Title"),
                        field: "title",
                        filter: "text",
                        filterParams: {filterOptions: ['contains']}
                    },
                    {
                        headerName: gettextCatalog.getString("Slug"),
                        field: "slug",
                        filter: "text",
                        filterParams: {filterOptions: ['contains']}
                    },
                    {
                        headerName: gettextCatalog.getString("Status"),
                        field: "status",
                        filter: "text",
                        filterParams: {filterOptions: ['startsWith']},
                        cellRenderer: function (params) {
                            let cls = params.value === 'public' ? 'success' : 'danger';
                            let label = angular.element(`<span class="text-${cls}"><i class="fa fa-circle"></i>&nbsp; ${gettextCatalog.getString(params.value.charAt(0).toUpperCase() + params.value.slice(1))}</span>`);
                            return label[0];
                        }

                    },
                    {
                        headerName: gettextCatalog.getString("Actions"),
                        suppressFilter: true,
                        cellRenderer: function (params) {
                            let buttons = angular.element('<div></div>');
                            let buttonEdit = angular.element(`<button class="btn btn-xs btn-primary">
                                    <em class="ion-edit"></em>
                                    ${gettextCatalog.getString('Edit')}
                                </button>`);

                            buttonEdit.on('click', function () {
                                $state.go('pagesEdit', {
                                    id: params.data.id,
                                    title: params.data.title,
                                    returnState: {
                                        name: 'pages',
                                        params: angular.copy($state.params)
                                    }
                                })
                            });
                            buttons.append(buttonEdit[0]);

                            let buttonShowFormData = angular.element(`<button class="btn btn-xs btn-primary">
                                    <em class="ion-android-clipboard"></em>
                                    ${gettextCatalog.getString('Show form data')}
                                </button>`);

                            buttonShowFormData.on('click', function () {
                                $state.go('pageFormDataList', {
                                    id: params.data.id,
                                    returnState: {
                                        name: 'pages',
                                        params: angular.copy($state.params)
                                    }
                                })
                            });
                            buttons.append(buttonShowFormData[0]);

                            return buttons[0];
                        }
                    }
                ];
            };

            this.options = {
                _columnDefsCallback: getColumnDefs,
                _gridStateId: 'page-grid-state'
            };

            this.initialFilterModel = {};
            let dataInitialized = false;


            const defaultParams = {
                title: undefined,
                slug: undefined,
                status: undefined,
                order_by: undefined,
                order_direction: undefined
            };

            this.$onInit = () => {
                if (!this.initialParams) {
                    this.initialParams = angular.copy(defaultParams);
                }

                if (this.initialParams.order_by) {
                    this.initialSortModel = [
                        {colId: this.initialParams.order_by, sort: this.initialParams.order_direction || 'asc'}
                    ];
                }

                if (this.initialParams.page) {
                    this.initialPage = this.initialParams.page;
                }


                ['title', 'slug', 'status'].forEach(field => {
                    if (this.initialParams[field])
                        this.initialFilterModel[field] = ({type: 'contains', filter: this.initialParams[field]});
                });


                this.datasource = {
                    getRows: params => {
                        let queryParams = GridParamsConverter.getCmsApiParams(params);
                        let stateParams = Object.assign({}, defaultParams, queryParams);

                        if (this.onParamsChange)
                            this.onParamsChange({params: angular.copy(stateParams)});

                        delete stateParams.page;
                        $state.go('.', stateParams, {
                            location: 'replace'
                        });

                        let responseData = [];
                        PageResource.findAll(queryParams, response => {
                                responseData = response.data;
                                let lastRow = response.total_count;
                                params.successCallback(responseData, lastRow);

                                if (!dataInitialized && this.initialPage && this.initialPage !== this.options.api.paginationGetCurrentPage() + 1) {
                                    dataInitialized = true;
                                    this.options.api.paginationGoToPage(parseInt(this.initialPage) - 1);
                                }
                            }, errResponse => {
                            }
                        );
                    }
                };
            };

            this._onPageChange = page => {
                if (!dataInitialized)
                    return;
                if (this.onPageChange)
                    this.onPageChange({$page: page});
            };
        }
    });

export default productsGridModule.name;




// WEBPACK FOOTER //
// ./src/cmsCore/PagesModules/PagesGrid/PagesGrid.js